import { useTranslations } from '../hooks/useTranslation'

const Logs = ({onvVeiwChange, ...props}) => {
    const { t } = useTranslations()
    
    return (
        <div className="archiving-logs">
            <button onClick={()=> onvVeiwChange('dashboard_settings')} className=" arcm-mb-4 arcm-flex arcm-items-center arcm-justify-center arcm-text-[#3858e9] arcm-text-sm arcm-font-semibold">
                <div className="icon arcm-mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                        <path d="M7.125 13.25L0.875 7L7.125 0.75" stroke="#3858E9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div> {t('back')}
            </button>
            <div className="arcm-text-gray-800 arcm-text-xl arcm-font-bold arcm-mb-4">{t('archiving_log')}</div>
            <div class="arcm-relative arcm-overflow-x-auto arcm-border arcm-border-gray-300 arcm-rounded-[5px] arcm-mb-8">
                <table class=" arcm-w-full arcm-text-gray-900 arcm-mb-0 arcm-text-xs sm:arcm-text-sm arcm-font-normal  arcm-border arcm-border-gray-300 arcm-rounded-[5px] arcm-overflow-hidden">
                    <thead class="arcm-bg-gray-200 arcm-text-left">
                        <tr>
                            <th class="arcm-bg-transparent arcm-text-gray-900 arcm-font-semibold arcm-px-3 arcm-py-3 sm:arcm-px-5 sm:arcm-py-5 arcm-border-none arcm-cursor-pointer">{t('action_performed')}</th>
                            <th class="arcm-bg-transparent arcm-text-gray-900 arcm-font-semibold arcm-px-3 arcm-py-3 sm:arcm-px-5 sm:arcm-py-5 arcm-border-none arcm-cursor-pointer">{t('date')}</th>
                            <th class="arcm-bg-transparent arcm-text-gray-900 arcm-font-semibold arcm-px-3 arcm-py-3 sm:arcm-px-5 sm:arcm-py-5 arcm-border-none arcm-cursor-pointer">{t('time')}</th>
                            <th class="arcm-bg-transparent arcm-text-gray-900 arcm-font-semibold arcm-px-3 arcm-py-3 sm:arcm-px-5 sm:arcm-py-5 arcm-border-none arcm-cursor-pointer">{t('status_label')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan={12} className="arcm-h-[240px]"></td>
                        </tr>
                    </tbody>
                </table>
                
            </div>
        </div>
    );

}

export default Logs;